import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Container } from 'reactstrap';
import AdminHeader from 'components/organisms/adminHeader';
import AdminClinicAddBlock from 'components/templates/admin/clinicAdd';
import { isAdmin, isPractice } from 'utils/userTypeHelper';
import useUser from 'utils/useUser';

const AdminClinicAdd = () => {
  const { userType } = useUser();
  const {
    adminPanelClinics: {
      getClinic,
      getClinics,
      getAgencies,
      getThreshold,
      getRepresentatives,
      reset,
    },
  } = useDispatch();

  const iamAdmin = isAdmin(userType);

  useEffect(async () => {
    reset();
    await getThreshold();
    if (iamAdmin) await getAgencies();
    if (!isPractice(userType)) await getRepresentatives();
    await getClinic();
    await getClinics({ items: null, noLimit: true });
  }, []);
  return (
    <Container>
      <AdminHeader />
      <AdminClinicAddBlock />
    </Container>
  );
};

export default AdminClinicAdd;
